var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"partner-box"},[_c('div',{staticClass:"en-title"},[_vm._v("COOPERATIVE PARTNER")]),_c('div',{staticClass:"cn-title"},[_vm._v("合作伙伴")]),_c('div',{staticClass:"content"},[_c('img',{attrs:{"src":require("@/assets/home/partner_img.png"),"alt":""}})])])
}]

export { render, staticRenderFns }